var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-display-flex gl-align-items-center"},[_c('gl-icon',{staticClass:"gl-ml-3 gl-mr-2",attrs:{"name":"package"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }